/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.S3FSDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractFsDriver2 = require('./AbstractFsDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * S3FS Cache Driver
 */
let S3FSDriver = exports.S3FSDriver = function (_AbstractFsDriver) {
  _inherits(S3FSDriver, _AbstractFsDriver);

  /**
   * @param {ContainerAware} containerAware
   * @param {String} directory
   */
  function S3FSDriver(containerAware) {
    let directory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _AbstractFsDriver2.AbstractFsDriver.DEFAULT_DIRECTORY;

    _classCallCheck(this, S3FSDriver);

    var _this = _possibleConstructorReturn(this, (S3FSDriver.__proto__ || Object.getPrototypeOf(S3FSDriver)).call(this, directory));

    _this._containerAware = containerAware;
    return _this;
  }

  /**
   * @returns {String}
   * @private
   */


  _createClass(S3FSDriver, [{
    key: '_type',
    value: function _type() {
      return 'S3FS';
    }

    /**
     * @param {String} key
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_has',
    value: function _has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      this._get(key, (err, data) => {
        callback(err, data !== null);
      });
    }

    /**
     * @param {String} key
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_get',
    value: function _get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      this._fs.readFile(key, (err, data) => {
        if (err) {
          callback(err, null);

          return;
        }

        try {
          var parsedData = JSON.parse(data);

          if (parsedData.expires && parsedData.expires < _AbstractFsDriver2.AbstractFsDriver._now || parsedData.buildId !== this._buildId) {
            this._invalidate(key);

            callback(null, null);

            return;
          }

          callback(null, parsedData.value);
        } catch (e) {
          // avoid parse error on missing or broken object in S3
          this._invalidate(key);

          callback(null, null);
        }
      });
    }

    /**
     * @param {String} key
     * @param {Object} value
     * @param {Number} ttl
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_set',
    value: function _set(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      let strObject = JSON.stringify({
        expires: ttl > 0 ? _AbstractFsDriver2.AbstractFsDriver._now + ttl : null,
        value: value,
        buildId: this._buildId
      });

      this._fs.mkdirp(this._directory, () => {
        this._fs.writeFile(key, strObject, err => {
          callback(err, !err);
        });
      });
    }

    /**
     * @param {String} key
     * @param {Number} timeout
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_invalidate',
    value: function _invalidate(key) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

      if (timeout <= 0) {
        this._fs.unlink(key, err => {
          callback(err, !err);
        });

        return;
      }

      this._get(key, (err, data) => {
        if (err) {
          callback(err, null);

          return;
        }

        this._set(key, data.value, timeout, callback);
      });
    }

    /**
     * @returns {s3fs}
     * @private
     */

  }, {
    key: '_fs',
    get: function get() {
      return this._containerAware.container.get('fs').public;
    }
  }]);

  return S3FSDriver;
}(_AbstractFsDriver2.AbstractFsDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/S3FSDriver.js
// module id = 355
// module chunks = 0